export enum RoleType {
  Submitter = 'submitter',
  Controller = 'controller',
  Admin = 'admin'
}
